import { Container } from "@material-ui/core";
import { UISref } from "@uirouter/react";
import * as React from "react";
import styled from "styled-components";
import { ReactComponent as LogoSVG } from "../../../../assets/sekuritance-logo.svg";
import { InfoButton } from "../../../../components/button";
import { Flex } from "../../../../components/layout";
import { useDefaultToEnglish } from "../../../../i18n";
import { colours } from "../../../../styles/colours";
import { device, size } from "../../../../styles/media";
import { DashboardRoutes } from "../../../dashboard/routes";
import { TokenOnboardingRoutes } from "../../../token-onboarding/routes";

const background = "#09263f";

export interface IHeaderProps {}

const HeaderWrapper = styled.header`
  background: ${colours.white};
  padding: 1em;
`;

const Title = styled.h2`
  margin-left: 0.3em;
  font-size: 2.1em;
  font-weight: 700;

  @media ${device.md} {
    width: auto;
  }
`;

const HomeCTA = styled(Flex)`
  cursor: pointer;

  @media ${device.md} {
    width: auto;
  }
`;

const TopBanner = styled(Flex)`
  justify-content: space-around;

  @media ${device.md} {
    justify-content: flex-end;
  }
`;

const TopBannerWrapper = styled(Flex)`
  background: ${background};
  padding: 0.5em 0;

  @media ${device.md} {
    padding: 0.5em 1em;
    justify-content: flex-end;
  }
`;

const TopButtons = styled(InfoButton)`
  background: ${background};
`;

const SpaceBetween = styled(Flex)`
  justify-content: space-between;
  flex-wrap: wrap;
`;

const StyledContainer = styled(Container).attrs({ maxWidth: "lg" })`
  @media (max-width: ${size.md - 1}px) {
    padding: 0;
  }
`;

export const Header: React.FunctionComponent<IHeaderProps> = () => {
  useDefaultToEnglish();
  return (
    <>
      <TopBannerWrapper>
        <StyledContainer>
          <TopBanner>
            <UISref to={DashboardRoutes.name}>
              <TopButtons icon="logout" variant="contained">
                SKRT Portal
              </TopButtons>
            </UISref>
            <TopButtons
              href="https://www.sekuritance.com/2021-Sekuritance/about-us/skrt-token/"
              icon="followMoney"
              variant="contained"
            >
              SKRT Token
            </TopButtons>
          </TopBanner>
        </StyledContainer>
      </TopBannerWrapper>
      <HeaderWrapper>
        <StyledContainer>
          <SpaceBetween>
            <UISref to={TokenOnboardingRoutes.names.externalMain}>
              <HomeCTA>
                <LogoSVG />
                <Title className="h2">Sekuritance</Title>
              </HomeCTA>
            </UISref>
          </SpaceBetween>
        </StyledContainer>
      </HeaderWrapper>
    </>
  );
};
